// extracted by mini-css-extract-plugin
export default {"LoadingSpinner":"LoadingSpinner_LoadingSpinner__+WqjL","loading":"LoadingSpinner_loading__wYRst"};